export default __webpack_public_path__ + "static/campbell-morrison-1-d69c5e994e715399f08f495a822608d1.webp";